import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/auth';

/* PRODUCTION */
let config = {
    apiKey: 'AIzaSyC6kgNVrCAbaKR1ccaRhojbn2yP0zJk58s',
    authDomain: 'triton-hearing-ipad-kiosk.firebaseapp.com',
    databaseURL: 'https://triton-hearing-ipad-kiosk.firebaseio.com',
    projectId: 'triton-hearing-ipad-kiosk',
    storageBucket: 'triton-hearing-ipad-kiosk.appspot.com',
    messagingSenderId: '802211451415'
};


/* DEVELOPMENT */
// let config = {
//     apiKey: "AIzaSyDbguv875mZTKbRDOj4W4GpvmvBGKMff8M",
//     authDomain: "dev-triton-hearing-ipad-kiosk.firebaseapp.com",
//     databaseURL: "https://dev-triton-hearing-ipad-kiosk-default-rtdb.firebaseio.com",
//     projectId: "dev-triton-hearing-ipad-kiosk",
//     storageBucket: "dev-triton-hearing-ipad-kiosk.appspot.com",
//     messagingSenderId: "927477982313",
// };

firebase.initializeApp(config);

export default firebase;
